import store from "@/store";
import { $paths } from "@/constants";
import { isEmpty } from "@/utils/common.utils";

/**
 * Auth guard router middleware
 * @description before each route, check if user needs auth
 * @param {Object} to - the route to change to
 * @param {Object} from - the previous route
 * @param {Object} next - callback
 */
const auth = (to, from, next) => {
  const { getters } = store;
  const isUserLoggedIn = getters["auth/isLoggedIn"];
  const isRouteAuthorised = to.matched.some(({ meta }) => meta.requiresAuth);

  // Redirects user to login page if there are no routes matched in the application
  if (isEmpty(to?.matched)) next({ name: "login" });
  // Redirect user to login page If current route is authorised and user is not logged in
  else if (to.name !== "login" && !isUserLoggedIn && isRouteAuthorised)
    next({ name: "login" });
  /**
   * Redirects user to dashboard page if user is logged in or route is not defined
   * @todo Change path: $paths.customers  to $paths.dashboard once dashboard view have been implemeted
   */ else if ((!to.name || to.name === "login") && isUserLoggedIn)
    next({ path: $paths.customers });
  else next();
};

export default {
  auth,
};
